import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { TrackingProvider } from "@core/features/tracking";
import { DashboardNavigationItemsContainer } from "@platform/layouts/DashboardNavigation";
import { AppLayout } from "@platform/layouts/AppLayout";

export type Props = {
  isWithNavigation?: boolean;
};

export function VideoEndLayout({ isWithNavigation = false }: Props) {
  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1"
        />
      </Helmet>
      <TrackingProvider
        debug={{ enabled: false }}
        services={{ posthog: true, google_analytics: true }}
      >
        {isWithNavigation ? (
          <AppLayout
            isWithSidebar
            sidebar={<DashboardNavigationItemsContainer />}
            title="Video"
            isWithFooter={false}
          >
            <main className="flex flex-1 h-full justify-center items-center">
              <Outlet />
            </main>
          </AppLayout>
        ) : (
          <main className="flex-grow flex flex-col bg-brand-50 h-full min-h-[100dvh]">
            <Outlet />
          </main>
        )}
      </TrackingProvider>
    </>
  );
}

export default VideoEndLayout;
